import { authHeader, handleResponse } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getFuseConfigurations() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/options/fuses`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getTestConfigurations() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/options/tests`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getProvisioningConfigurations() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/iot/enrollments`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const configurationOptionsService = {
  getFuseConfigurations,
  getTestConfigurations,
  getProvisioningConfigurations,
};
